import React from 'react';

class Contact extends React.Component {
    componentDidMount() {
        console.log("Initializing Photography.Contact..");
        // function hideContactlink() {
        //     let contactLink = document.getElementById('Contact-link');
        //     contactLink.className = 'dimNavLink';
        // };

        //doing this from NavBar now
        // hideContactlink();
    }

    render() {
        return (
            <div align="center">
                <p>
                    <b>Contact : cjmarek1@gmail.com</b>
                </p>
                <p>Enjoy Nature!</p>
                <br></br>
            </div>
        );
    }
}

export default Contact;